module.exports = __webpack_public_path__ + "static/media/wash_hygiene.3612798b.svg";